export default __webpack_public_path__ + "static/3-b230cfd20bd712e1de2b4d7237d381f2.jpeg";